import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { getIsUserImpersonated } from '../selectors/AuthSelector';
import { jsx as _jsx } from "react/jsx-runtime";
const UserImpersonationAlert = () => {
  const isUserImpersonated = useSelector(getIsUserImpersonated);
  if (!isUserImpersonated) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIAlert, {
    className: "m-bottom-4",
    type: "tip",
    children: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.alerts.userImpersonation"
      })
    })
  });
};
export default UserImpersonationAlert;